import { render, staticRenderFns } from "./WonderStrategyPanorama.vue?vue&type=template&id=45b8a696&scoped=true"
import script from "./WonderStrategyPanorama.vue?vue&type=script&lang=js"
export * from "./WonderStrategyPanorama.vue?vue&type=script&lang=js"
import style0 from "./WonderStrategyPanorama.vue?vue&type=style&index=0&id=45b8a696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8a696",
  null
  
)

export default component.exports